module.exports = __webpack_public_path__ + "static/img/logo_9@2x.b5915bbc.png";